module.exports = __webpack_public_path__ + "img/qr.a3b73c6d.jpg";